import { Button, Tooltip } from "flowbite-react";
import { useEffect, useState } from "react";
import UserListTable from "./UserListTable";
import { toast } from "react-toastify";
import Loader from "../Common/Loader";
import { User } from "../../Models/User";
import { useAppSelector } from "../../Reducers/store";
import AddUserModal from "./AddUserModal";
import { UserLevelNames } from "../../Models/UserLevel";
import { useParams } from "react-router-dom";
import UserApi from "../../Api/UserApi";
import { HiPlus } from "react-icons/hi";

export default function UserList() {
  const { id } = useParams();
  const { userModel } = useAppSelector((state) => state.user);
  const [userListData, setUserListData] = useState<User[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [showAddUser, setShowAddUser] = useState<boolean>(false);

  useEffect(() => {
    getUsers();
  }, [userModel]);

  const getUsers = () => {
    if (userModel) {
      try {
        setIsLoading(true);
        return UserApi.getUserList()
          .then((res) => {
            setUserListData(res.data);

            setIsLoading(false);
          })
          .catch((err) => {
            toast.error("Error");
            setIsLoading(false);
          });
      } catch (error) {
        console.error(error);
        toast.error("Error");
        setIsLoading(false);
      }
    }
  };

  const handleAddUserClick = () => {
    setShowAddUser(true);
  };

  const deleteUser = (id: number) => {
    // Find the user to get their name for the confirmation
    const user = userListData.find((u) => u.id === id);
    const userName = user
      ? `${user.firstName || ""} ${user.lastName || ""}`.trim()
      : "this user";

    const shouldRemove = window.confirm(
      `Delete User Confirmation\n\n` +
        `Are you sure you want to permanently delete ${userName}?\n\n` +
        `This action will:\n` +
        `• Remove the user from the system\n` +
        `• Cannot be undone\n` +
        `• May fail if the user has associated records\n\n` +
        `Click OK to proceed with deletion, or Cancel to abort.`
    );

    if (shouldRemove) {
      setIsLoading(true);
      UserApi.deleteUser(id)
        .then((res) => {
          if (res.data.success) {
            toast.success(`User ${userName} has been successfully deleted.`);
            getUsers();
          } else {
            toast.error(
              `Failed to delete user: ${
                res.data.message || "Unknown error occurred"
              }`
            );
          }
          setIsLoading(false);
        })
        .catch((err) => {
          console.error("Delete user error:", err);
          let errorMessage =
            "An unexpected error occurred while deleting the user.";

          if (err.response?.data?.message) {
            errorMessage = `Delete failed: ${err.response.data.message}`;
          } else if (err.message) {
            errorMessage = `Network error: ${err.message}`;
          }

          toast.error(errorMessage);
          setIsLoading(false);
        });
    }
  };

  function checkAccess() {
    // if (userModel && userModel.userLevelId === UserLevelNames.SuperAdmin) {
    if (userModel) {
      return true;
    } else {
      return false;
    }
  }

  return (
    <>
      <div className="w-full">
        <div className="w-full h-[74px] p-4">
          <div className="mx-1 flex items-end">
            <div className="flex flex-1">
              <h1 className="text-gray-900 font-bold text-4xl">
                <div>User List</div>
              </h1>
            </div>
            {checkAccess() && (
              <div className="">
                <Tooltip content="Add User">
                  <Button onClick={handleAddUserClick} className="buttonMain">
                    <HiPlus size={20} />
                  </Button>
                </Tooltip>
              </div>
            )}
          </div>
        </div>
        <div className="w-full p-4 h-[calc(100vh-132px)] md:h-[calc(100vh-200px)] overflow-y-auto">
          <div className="relative">
            {isLoading && <Loader />}
            <UserListTable data={userListData} deleteUser={deleteUser} />
          </div>
        </div>
      </div>
      <AddUserModal show={showAddUser} setShow={setShowAddUser}></AddUserModal>
    </>
  );
}
